import { MainCard, MainCardTitle } from "src/components/main-card-type.tsx";
import { normalSanatizerBRL } from "src/utils/functions";
import { CompoundInterestGraph } from "./CompoundInterestGraph";
import CompoundInterestTable from "./CompoundInterestTable";

export const CompoundInterestResponse = ({
  results,
}: {
  results: ResultsType;
}) => {
  const monthlyAcumulatedInterest = results.monthlyResult.map(
    (value: any, index: string | number) => {
      return value + results.monthlyInvested[index];
    }
  );

  const updatedResults: ResultsType = { ...results, monthlyAcumulatedInterest };

  return (
    <MainCard className="mt-4">
      <MainCardTitle>Resultado</MainCardTitle>
      <div className="grid sm:grid-cols-3 gap-4 mb-2 grid-cols-1">
        <div className="p-3 bg-primary rounded border flex flex-col justify-center">
          <h2 className="sm:text-base text-sm text-center text-white font-semibold m-0">
            Valor total final
          </h2>
          <p className="sm:text-xl text-center font-bold text-md text-white m-0">
            <span className="text-sm mr-1 text-white">R$</span>
            {normalSanatizerBRL(results.accumulated)}
          </p>
        </div>
        <div className="p-3 bg-white rounded border flex flex-col justify-center">
          <h2 className="sm:text-base text-sm text-center font-semibold m-0">
            Valor total investido
          </h2>
          <p className="sm:text-lg text-center font-black text-md text-red-800 m-0">
            <span className="text-sm mr-1 text-gray-500">R$</span>
            {normalSanatizerBRL(results.invested)}
          </p>
        </div>
        <div className="p-3 bg-white rounded border flex flex-col justify-center">
          <h2 className="sm:text-base text-sm text-center font-semibold m-0">
            Total em juros
          </h2>
          <p className="sm:text-lg text-center font-black text-md text-black m-0">
            <span className="text-sm mr-1 text-gray-500">R$</span>
            {normalSanatizerBRL(results.interest)}
          </p>
        </div>
      </div>

      <h2 className="font-bold text-primary text-lg mt-8 text-center">
        Gráfico:
      </h2>
      <CompoundInterestGraph
        results={results}
        monthlyAcumulatedInterest={monthlyAcumulatedInterest}
      />
      <h2 className="font-bold text-primary text-lg my-6 text-center">
        Tabela:
      </h2>
      <CompoundInterestTable results={updatedResults} />
    </MainCard>
  );
};
